import PermissionInfo from "@components/permissions/permissionInfo";
import { LoadingButton } from "@mui/lab";
import { Button, ButtonProps, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface ILockedButtonProps extends ButtonProps {
  buttonText: string | ReactNode;
  locked: boolean;
  moduleLocked?: boolean;
  loading?: boolean;
}

export const LockedButton: React.FC<ILockedButtonProps> = (props) => {
  const {
    onClick,
    buttonText,
    variant = "contained",
    disabled = false,
    locked,
    moduleLocked,
    loading = false,
    endIcon,
    sx,
    ...others
  } = props;
  const { palette } = useTheme();

  const lockedSx =
    locked && variant !== "contained"
      ? {
          color: palette.text.disabled,
          borderColor: palette.text.disabled,
          "&:hover": {
            borderColor: palette.text.disabled,
            backgroundColor: "transparent",
          },
        }
      : {};

  const commonProps = {
    variant,
    size: "medium" as const,
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
      if (!locked) {
        onClick?.(e);
      }
    },
    disabled,
    endIcon: locked ? (
      <PermissionInfo
        moduleLocked={moduleLocked}
        customColor={variant === "contained" ? "#fff" : undefined}
      />
    ) : (
      endIcon
    ),
    sx: [lockedSx, ...(Array.isArray(sx) ? sx : [sx])],
    ...others,
  };

  return (
    <div>
      {loading ? (
        <LoadingButton loading={loading} {...commonProps}>
          {buttonText}
        </LoadingButton>
      ) : (
        <Button {...commonProps}>{buttonText}</Button>
      )}
    </div>
  );
};
